import type { PageCard } from '@/play/pageTypes'
import { FingerPaintingCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'finger-painting',
  number: 28,
  title: 'Finger painting',
  question: 'Does painting with a finger in puffy, shiny 3D paint feel as good as real finger paint?',
  status: 'open',
  accent: '#f4e8c8',
  CardArt: FingerPaintingCardArt,
}
